var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"40","height":"50","viewBox":"0 0 40 50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 50V0H40L25.2308 25L40 50H0Z","fill":"#8A1686"}})])}
var staticRenderFns = []

export { render, staticRenderFns }